module.exports = __webpack_public_path__ + "img/no-data-chart.6f9af8ff.svg";